import React from 'react';
import { getNavTheme } from '../../../../../navigation/clinicNavConfig';
import PatientDetailIcon from './PatientDetailIcon';

function PatientDetailSegmentNav({ tabs, activeTab, onTabChange }) {
    return (
        <div className="patient-detail-segment" role="tablist" aria-label="Patient detail sections">
            {tabs.map((tab) => {
                const theme = getNavTheme(tab.theme);
                const isActive = activeTab === tab.id;

                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`patient-detail-segment__item ${
                            isActive ? `${theme.activeClass} is-active` : theme.idleClass
                        }`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <PatientDetailIcon icon={tab.icon} theme={tab.theme} size="sm" />
                        <span className="patient-detail-segment__label">{tab.label}</span>
                    </button>
                );
            })}
        </div>
    );
}

export default PatientDetailSegmentNav;
